import { render, staticRenderFns } from "./GraphControls.vue?vue&type=template&id=1a5c60f6&scoped=true"
import script from "./GraphControls.vue?vue&type=script&lang=js"
export * from "./GraphControls.vue?vue&type=script&lang=js"
import style0 from "./GraphControls.vue?vue&type=style&index=0&id=1a5c60f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c60f6",
  null
  
)

export default component.exports